import * as React from 'react';

export interface ContentProps {
  id?: string;
  containerView?: string;
  children?: React.ReactNode | React.ReactNode[];
}

export class Content extends React.Component<ContentProps> {
  render() {
    const {id, children} = this.props;
    return (  
      <div id={id} className="content">
        {children}
      </div>
    )
  }
}